import { Alert, Button, Intent, Menu, MenuItem, Popover, Position } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import AppToaster from '../../../AppToaster';
import { TagDetailPageFragment, useDeleteTagMutation } from '../../../generated/graphql';
import { showErrorMessage } from '../../../helpers/graphql';

type TagDetailMenuProps = {
  tag: TagDetailPageFragment;
  onEdit: () => void;
};

const TagDetailMenu = ({ tag, onEdit }: TagDetailMenuProps) => {
  const history = useHistory();
  const [isDeleteAlertOpen, setIsDeleteAlertOpen] = useState(false);
  const [deleteTag, { loading: deleting }] = useDeleteTagMutation({
    variables: {
      id: tag.id,
    },
    onCompleted: () => {
      AppToaster.success(`${tag.name} wurde entfernt`);
      history.goBack();
    },
    onError: showErrorMessage,
  });

  return (
    <>
      <Alert
        isOpen={isDeleteAlertOpen}
        cancelButtonText="Abbrechen"
        confirmButtonText="Entfernen"
        icon={IconNames.DELETE}
        intent={Intent.DANGER}
        onClose={() => setIsDeleteAlertOpen(false)}
        onConfirm={deleteTag as any}
      >
        <p>Soll dieses Attribut wirklich undwiderruflich entfernt werden?</p>
      </Alert>
      <Button text="Bearbeiten" icon={IconNames.EDIT} className="ml-2" onClick={onEdit} />
      <Popover
        position={Position.BOTTOM}
        content={
          <Menu>
            <MenuItem
              text="Entfernen"
              icon={IconNames.DELETE}
              intent={Intent.DANGER}
              onClick={() => setIsDeleteAlertOpen(true)}
            />
          </Menu>
        }
      >
        <Button icon={IconNames.MORE} className="ml-2" loading={deleting} />
      </Popover>
    </>
  );
};

export default TagDetailMenu;
